import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function FleetCard({ model, image, ctaLabel }) {
  return (
    <div
      data-testid={`fleet-card-${model.id}`}
      className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0F1015] transition-colors duration-500 hover:border-gold/40"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={image}
          alt={model.name}
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1015] via-transparent to-transparent" />
        <span className="absolute top-4 left-4 font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold-soft bg-black/55 backdrop-blur px-3 py-1.5 rounded-full border border-white/10">
          {model.category}
        </span>
      </div>

      <div className="p-6 lg:p-8">
        <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-white">{model.name}</h3>
        <dl className="mt-6 grid grid-cols-2 gap-3">
          {[
            { l: model.labels.range, v: model.range },
            { l: model.labels.accel, v: model.accel },
            { l: model.labels.seats, v: model.seats },
            { l: model.labels.luggage, v: model.luggage }
          ].map(({ l, v }) => (
            <div key={l} className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
              <dt className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500">{l}</dt>
              <dd className="mt-1.5 font-mono2 text-base lg:text-lg text-gold-soft">{v}</dd>
            </div>
          ))}
        </dl>
        {ctaLabel && (
          <Link
            to="/contact"
            data-testid={`fleet-card-cta-${model.id}`}
            className="mt-6 inline-flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.2em] text-gold-soft hover:text-gold-pale transition-colors"
          >
            {ctaLabel} <ArrowRight size={14} />
          </Link>
        )}
      </div>
    </div>
  );
}

export default FleetCard;
